import {
  useEngineStatus,
  UseEngineStatusSelector
} from '@surveycake/react-logic-engine';
import React, { createContext, FC, useContext, useMemo, useState } from 'react';

export interface FileUploadLockMethods {
  /**
   * To add one lock.
   */
  lock: () => void;
  /**
   * To release one lock.
   */
  unlock: () => void;
}

export interface IGoPageAndSubmitDisabledService extends FC {
  useDisabled: () => boolean;
  useFileUploadLockMethods: () => FileUploadLockMethods;
}

const DisabeldContext = createContext(false);
const FileUploadLockMethodsContext = createContext<FileUploadLockMethods>(
  {} as FileUploadLockMethods
);

/**
 * If there is no anyone pending or countdowning then enabled, or disabled.
 */
const engineDisabledSelector: UseEngineStatusSelector<boolean> = status =>
  status.pending > 0 || status.timer;

/**
 * Either engine disabled or file upload locked will be disabled.
 *
 * @todo For now the react service of file upload lock is just workaround.
 * If we want to separate service and view exactly, it should be implemented by logic engine on v2.
 */
export const GoPageAndSubmitDisabledService: IGoPageAndSubmitDisabledService = ({
  children
}) => {
  const engineDisabled = useEngineStatus(engineDisabledSelector);
  const [fileUploadLock, originalSetFileUploadLock] = useState(0);
  const disabled = engineDisabled || fileUploadLock > 0;
  const setFileUploadLockMethods = useMemo(
    () => ({
      lock: () => originalSetFileUploadLock(prevState => prevState + 1),
      unlock: () => originalSetFileUploadLock(prevState => prevState - 1)
    }),
    []
  );

  return (
    <FileUploadLockMethodsContext.Provider value={setFileUploadLockMethods}>
      <DisabeldContext.Provider value={disabled}>
        {children}
      </DisabeldContext.Provider>
    </FileUploadLockMethodsContext.Provider>
  );
};

const useDisabled = () => useContext(DisabeldContext);
const useFileUploadLockMethods = () => useContext(FileUploadLockMethodsContext);

GoPageAndSubmitDisabledService.useDisabled = useDisabled;
GoPageAndSubmitDisabledService.useFileUploadLockMethods = useFileUploadLockMethods;
